/* eslint-disable no-unused-vars */
import sh1 from '../images/products/sh1.png';
import sh2 from '../images/products/sh2.png';
import sh3 from '../images/products/sh3.png';
import sh4 from '../images/products/sh4.png';
import sh5 from '../images/products/sh5.png';
import sh6 from '../images/products/sh6.png';
import sh7 from '../images/products/sh7.png';
import sh8 from '../images/products/sh8.png';
import sh9 from '../images/products/sh9.png';
import sh10 from '../images/products/sh10.png';
import sh11 from '../images/products/sh11.png';
import sh12 from '../images/products/sh12.png';
import sh13 from '../images/products/sh13.png';
import sh14 from '../images/products/sh14.png';
import sh15 from '../images/products/sh15.png';
import sh16 from '../images/products/sh16.png';
import sh17 from '../images/products/sh17.png';
import sh18 from '../images/products/sh18.png';
import sh19 from '../images/products/sh19.png';
import sh20 from '../images/products/sh20.png';

export const categories: Record<
  string,
  {
    src: string;
    src2: string;
    type: string;
    title: string;
    description1: string;
    description2: string;
    description3: string;
    link: string;
    detail1?: string;
    detail2?: string;
    detail3?: string;
    row1?: string;
    row1_2?: string;
    row1_3?: string;
    row2?: string;
    row2_2?: string;
    row2_3?: string;
    row3?: string;
    row3_2?: string;
    row3_3?: string;
    row4?: string;
    row4_2?: string;
    row4_3?: string;
    row5?: string;
    row5_2?: string;
    row5_3?: string;
    colors?: { color: string; imageLink: string }[]; // New property for colors
  }[]
> = {
  'External Blinds': [
    {
      src: 'https://www.neva.eu/wp-content/cache/image/neva-lamela-z-90-1-330x350-c-center.webp',
      src2: 'https://www.neva.eu/wp-content/cache/image/neva-venkovni-zaluzie-z-90-kryci-plech-1-1-600x600-c-center.webp',
      type: 'External Blinds',
      title: 'Z-90',
      description1: '+ Close-fitting slats',
      description2: '+ A hit among blinds',
      description3: '+ Very solid slats',
      link: '/product-details/External Blinds/Z-90',
      detail1:
        'It is the best-selling type of external blinds with great shading features and stiffness. Compared to the Z-70, the Z-90 have wider slats that are perfect for shading French windows or big glass walls.',
      detail2:
        'We manufacture Z-90 blinds within a standard 14-day production period. They are adjusted and ready for immediate installation on the building. We also provide an additional guarantee of 2+2 years.',
      detail3:
        'Z-90 external blinds can be controlled using a crank, motor or can be connected to the Smart Home system for automatic control according to your needs.',
      row1: 'Z-90 blinds',
      row1_2: 'Crank',
      row1_3: 'Motor',
      row2: 'Blind width (mm)',
      row2_2: '400 - 5 000',
      row2_3: '600 - 5 000',
      row3: 'Blind height (mm)',
      row3_2: '500 - 5 000',
      row3_3: '500 - 5 000',
      row4: 'Maximum blind surface (m2)',
      row4_2: '9',
      row4_3: '20',
      row5: 'Wind resistance',
      row5_2: 'up to 88 km/h, up to Class 6',
      row5_3: 'up to 88 km/h, up to Class 6',
      colors: [
        {
          color: '010 (RAL 9003/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/010.jpg',
        },
        {
          color: '071 (VSR071/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/071.jpg',
        },
        {
          color: '110 (VSR110/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/110.jpg',
        },
        {
          color: '130 (RAL 7038/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/130.jpg',
        },
        {
          color: '140 (RAL 9006/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/140.jpg',
        },
        {
          color: '140H (RAL 9006/H)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/140H.jpg',
        },
        {
          color: '240 (VSR240/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/240.jpg',
        },
        {
          color: '266 (January2)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/266.jpg',
        },
        {
          color: '330 (RAL 3004/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/330.jpg',
        },
        {
          color: '716 (RAL 7016/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/716.jpg',
        },
        {
          color: '721 (RAL 7021/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/721.jpg',
        },
        {
          color: '722 (RAL 7022/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/722.jpg',
        },
        {
          color: '735 (RAL 7035/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/735.jpg',
        },
        {
          color: '737 (RAL 7037/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/737.jpg',
        },
        {
          color: '739 (RAL 7039)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/739.jpg',
        },
        {
          color: '780 (VSR780/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/780.jpg',
        },
        {
          color: '905 (RAL 9005/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/905.jpg',
        },
        {
          color: '907 (RAL 9007/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/907.jpg',
        },
        {
          color: '908 (SW203G/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/908.jpg',
        },
        {
          color: '910 (RAL 9010/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/910.jpg',
        },
        {
          color: 'DB703 (DB703/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/DB703.jpg',
        },
        {
          color: 'YW359F (YW359F)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-90/YW359F.jpg',
        },
      ],
    },
    {
      src: 'https://www.neva.eu/wp-content/cache/image/neva-lamela-c-80-1-330x350-c-center.webp',
      src2: 'https://www.neva.eu/wp-content/cache/image/neva-venkovni-zaluzie-c-80-kryci-plech-1-1-600x600-c-center.webp',
      type: 'External Blinds',
      title: 'C-80',
      description1: '+ You can tilt the blinds in both directions',
      description2: '+ Variable solution',
      description3: '+ Interesting architectonic rendering',
      link: '/product-details/External Blinds/C-80',
      detail1:
        'Thanks to the possibility to tilt the slats in both directions, the shape of the C blinds allows you to precisely regulate the shading and to let in only the desired amount of sunlight. Unlike the C-65, the C-80 have more robust slats and can thus cover a bigger surface.',
      detail2:
        'We adjust the blinds during production so you can simply unpack and install them on the building site. We always manufacture them within 14 days and also add a guarantee of 2+2 years.',
      detail3:
        'C-80 external blinds can be controlled using a crank, motor or can be connected to the Smart Home system. We will custom make slat guides for you with a guide profile or cable.',
      row1: 'C-80 blinds',
      row1_2: 'Crank',
      row1_3: 'Motor',
      row2: 'Blind width (mm)',
      row2_2: '400 - 5 000',
      row2_3: '600 - 5 000',
      row3: 'Blind height (mm)',
      row3_2: '500 - 5 000',
      row3_3: '500 - 5 000',
      row4: 'Maximum blind surface (m2)',
      row4_2: '9',
      row4_3: '20',
      row5: 'Wind resistance',
      row5_2: 'up to 74 km/h, up to Class 5',
      row5_3: 'up to 74 km/h, up to Class 5',
      colors: [
        {
          color: '010 (RAL 9003/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/010.jpg',
        },
        {
          color: '071 (VSR071/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/071.jpg',
        },
        {
          color: '110 (VSR110/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/110.jpg',
        },
        {
          color: '130 (RAL 7038/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/130.jpg',
        },
        {
          color: '140 (RAL 9006/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/140.jpg',
        },
        {
          color: '140H (RAL 9006/H)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/140H.jpg',
        },
        {
          color: '240 (VSR240/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/240.jpg',
        },
        {
          color: '266 (January2)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/266.jpg',
        },
        {
          color: '330 (RAL 3004/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/330.jpg',
        },
        {
          color: '716 (RAL 7016/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/716.jpg',
        },
        {
          color: '721 (RAL 7021/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/721.jpg',
        },
        {
          color: '722 (RAL 7022/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/722.jpg',
        },
        {
          color: '735 (RAL 7035/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/735.jpg',
        },
        {
          color: '737 (RAL 7037/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/737.jpg',
        },
        {
          color: '739 (RAL 7039)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/739.jpg',
        },
        {
          color: '780 (VSR780/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/780.jpg',
        },
        {
          color: '905 (RAL 9005/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/905.jpg',
        },
        {
          color: '907 (RAL 9007/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/907.jpg',
        },
        {
          color: '908 (SW203G/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/908.jpg',
        },
        {
          color: '910 (RAL 9010/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/910.jpg',
        },
        {
          color: 'DB703 (DB703/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/DB703.jpg',
        },
        {
          color: 'YW359F (YW359F)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-80/YW359F.jpg',
        },
      ],
    },
    {
      src: 'https://www.neva.eu/wp-content/cache/image/neva-lamela-z-70-1-330x350-c-center.webp',
      src2: 'https://www.neva.eu/wp-content/cache/image/neva-venkovni-zaluzie-z-70-kryci-plech-1-1-600x600-c-center.webp',
      type: 'External Blinds',
      title: 'Z-70',
      description1: '+ Close-fitting slats',
      description2: '+ Elegant appearance',
      description3: '+ Flexible solution',
      link: '/product-details/External Blinds/Z-70',
      detail1:
        'The pleasantly quiet blinds are perfect also for smaller rooms with small windows. Compared to the Z-90, the Z-70 have more slats that are thinner and very elegant looking. Thanks to the width of the slats, they are perfect for narrower spaces in the façade.',
      detail2:
        'We adjust Z-70 blinds for you during production so they are ready for installation on the building site. We always manufacture them within 14 days and also add a guarantee of 2+2 years.',
      detail3:
        'Z-70 external blinds can be controlled using a crank, motor or can be connected to the Smart Home system for automatic control according to your needs.',
      row1: 'Z-70 blinds',
      row1_2: 'Crank',
      row1_3: 'Motor',
      row2: 'Blind width (mm)',
      row2_2: '400 - 5 000',
      row2_3: '600 - 5 000',
      row3: 'Blind height (mm)',
      row3_2: '500 - 5 000',
      row3_3: '500 - 5 000',
      row4: 'Maximum blind surface (m2)',
      row4_2: '9',
      row4_3: '20',
      row5: 'Wind resistance',
      row5_2: 'up to 88 km/h, up to Class 6',
      row5_3: 'up to 88 km/h, up to Class 6',
      colors: [
        {
          color: '010 (RAL 9003/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/010.jpg',
        },
        {
          color: '071 (VSR071/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/071.jpg',
        },
        {
          color: '110 (VSR110/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/110.jpg',
        },
        {
          color: '130 (RAL 7038/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/130.jpg',
        },
        {
          color: '140 (RAL 9006/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/140.jpg',
        },
        {
          color: '140H (RAL 9006/H)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/140H.jpg',
        },
        {
          color: '240 (VSR240/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/240.jpg',
        },
        {
          color: '266 (January2)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/266.jpg',
        },
        {
          color: '330 (RAL 3004/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/330.jpg',
        },
        {
          color: '716 (RAL 7016/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/716.jpg',
        },
        {
          color: '721 (RAL 7021/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/721.jpg',
        },
        {
          color: '722 (RAL 7022/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/722.jpg',
        },
        {
          color: '735 (RAL 7035/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/735.jpg',
        },
        {
          color: '737 (RAL 7037/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/737.jpg',
        },
        {
          color: '739 (RAL 7039)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/739.jpg',
        },
        {
          color: '780 (VSR780/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/780.jpg',
        },
        {
          color: '905 (RAL 9005/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/905.jpg',
        },
        {
          color: '907 (RAL 9007/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/907.jpg',
        },
        {
          color: '908 (SW203G/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/908.jpg',
        },
        {
          color: '910 (RAL 9010/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/910.jpg',
        },
        {
          color: 'DB703 (DB703/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/DB703.jpg',
        },
        {
          color: 'YW359F (YW359F)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/Z-70/YW359F.jpg',
        },
      ],
    },
    {
      src: 'https://www.neva.eu/wp-content/cache/image/neva-lamela-f-80-1-330x350-c-center.webp',
      src2: 'https://www.neva.eu/wp-content/cache/image/NEVA-venkovni-zaluzie-F-80-v-kryci-plech-11-600x600-c-center.webp',
      type: 'External Blinds',
      title: 'F-80',
      description1: '+ You can tilt the blinds in both directions',
      description2: '+ Save space',
      description3: '+ Variable solution',
      link: '/product-details/External Blinds/F-80',
      detail1:
        'Thanks to their elegant appearance and the fact that they do not reduce the clear height of the window, the F-80 blinds are among the most popular type of external blinds for households and administrative buildings. They are flat with a low packet and can be tilted in both directions.',
      detail2:
        'We adjust the blinds during production so you can install them immediately upon unpacking. We manufacture them within 14 days and also add a guarantee of 2+2 years.',
      detail3:
        'F-80 blinds can be controlled using a crank, or motor. You can also connect them to the Smart Home system. We will custom make slat guides for you with a guide profile or cable.',
      row1: 'F-80 blinds',
      row1_2: 'Crank',
      row1_3: 'Motor',
      row2: 'Blind width (mm)',
      row2_2: '400 - 4 000',
      row2_3: '600 - 4 000',
      row3: 'Blind height (mm)',
      row3_2: '500 - 4 000',
      row3_3: '500 - 4 000',
      row4: 'Maximum blind surface (m2)',
      row4_2: '9',
      row4_3: '16',
      row5: 'Wind resistance',
      row5_2: 'up to 61 km/h, up to Class 4',
      row5_3: 'up to 61 km/h, up to Class 4',
      colors: [
        {
          color: '140H (RAL 9006/H)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/F-80/140H.jpg',
        },
        {
          color: '010H (RAL 9003/H)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/F-80/010H.jpg',
        },
        {
          color: '716H (RAL 7016/H)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/F-80/716H.jpg',
        },
        {
          color: '907H (RAL 9007/H)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/F-80/907H.jpg',
        },
        {
          color: '908H (SW203G/H)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/F-80/908H.jpg',
        },
      ],
    },
    {
      src: 'https://www.neva.eu/wp-content/cache/image/neva-lamela-s-90-1-330x350-c-center.webp',
      src2: 'https://www.neva.eu/wp-content/cache/image/neva-venkovni-zaluzie-s-90-kryci-plech-1-1-600x600-c-center.webp',
      type: 'External Blinds',
      title: 'S-90',
      description1: '+ Close-fitting slats',
      description2: '+ Quiet operation',
      description3: '+ Similar to window roller shutters',
      link: '/product-details/External Blinds/S-90',
      detail1:
        'Because the S-90 blind slats fit together so well, they can completely shut out any light. They have the strongest slats of all our blinds, and for this reason, they can boast of high resistance. They look similar to window roller shutters, and you can combine them in a great way.',
      detail2:
        'S-90 blinds are already adjusted in production to enable you to simply unpack and immediately anchor them on the building site. Moreover, we always manufacture them within 14 days and also add a guarantee of 2+2 years.',
      detail3:
        'S-90 external blinds can be controlled by crank or motor. They can also be connected to the Smart Home system for automatic control according to your needs.',
      row1: 'S-90 blinds',
      row1_2: 'Crank',
      row1_3: 'Motor',
      row2: 'Blind width (mm)',
      row2_2: '400 - 5 000',
      row2_3: '600 - 5 000',
      row3: 'Blind height (mm)',
      row3_2: '500 - 5 000',
      row3_3: '500 - 5 000',
      row4: 'Maximum blind surface (m2)',
      row4_2: '9',
      row4_3: '20',
      row5: 'Wind resistance',
      row5_2: 'up to 88 km/h, up to Class 6',
      row5_3: 'up to 88 km/h, up to Class 6',
      colors: [
        {
          color: '010 (RAL 9003/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/010.jpg',
        },
        {
          color: '071 (VSR071/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/071.jpg',
        },
        {
          color: '110 (VSR110/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/110.jpg',
        },
        {
          color: '130 (RAL 7038/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/130.jpg',
        },
        {
          color: '140 (RAL 9006/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/140.jpg',
        },
        {
          color: '140H (RAL 9006/H)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/140H.jpg',
        },
        {
          color: '240 (VSR240/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/ S-90/240.jpg',
        },
        {
          color: '266 (January2)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/266.jpg',
        },
        {
          color: '330 (RAL 3004/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/330.jpg',
        },
        {
          color: '716 (RAL 7016/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/716.jpg',
        },
        {
          color: '721 (RAL 7021/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/721.jpg',
        },
        {
          color: '722 (RAL 7022/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/722.jpg',
        },
        {
          color: '735 (RAL 7035/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/735.jpg',
        },
        {
          color: '737 (RAL 7037/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/737.jpg',
        },
        {
          color: '739 (RAL 7039)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/739.jpg',
        },
        {
          color: '780 (VSR780/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/780.jpg',
        },
        {
          color: '905 (RAL 9005/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/905.jpg',
        },
        {
          color: '907 (RAL 9007/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/907.jpg',
        },
        {
          color: '908 (SW203G/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/908.jpg',
        },
        {
          color: '910 (RAL 9010/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/910.jpg',
        },
        {
          color: 'DB703 (DB703/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/DB703.jpg',
        },
        {
          color: 'YW359F (YW359F)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/S-90/YW359F.jpg',
        },
      ],
    },
    {
      src: 'https://www.neva.eu/wp-content/cache/image/neva-lamela-c-65-1-330x350-c-center.webp',
      src2: 'https://www hail.neva.eu/wp-content/cache/image/neva-venkovni-zaluzie-c-65-kryci-plech-1-1-600x600-c-center.webp',
      type: 'External Blinds',
      title: 'C-65',
      description1: '+ You can tilt the blinds in both directions',
      description2: '+ Elegant appearance',
      description3: '+ Variable solution',
      link: '/product-details/External Blinds/C-65',
      detail1:
        'For everyone who wants to have perfect control of shielding. Compared to the C-80, the more elegant-looking C-65 blinds have narrower slats, and are therefore suitable for places with smaller or narrower windows.',
      detail2:
        'We adjust the blinds during production so you can simply unpack and anchor them on the building site. We always manufacture them within 14 days and also add a guarantee of 2+2 years.',
      detail3:
        'C-65 external blinds can be controlled using a crank, motor or can be connected to the Smart Home system. We will custom make slat guides for you with a guide profile or cable.',
      row1: 'C-65 blinds',
      row1_2: 'Crank',
      row1_3: 'Motor',
      row2: 'Blind width (mm)',
      row2_2: '400 - 5 000',
      row2_3: '600 - 5 000',
      row3: 'Blind height (mm)',
      row3_2: '500 - 5 000',
      row3_3: '500 - 5 000',
      row4: 'Maximum blind surface (m2)',
      row4_2: '9',
      row4_3: '20',
      row5: 'Wind resistance',
      row5_2: 'up to 74 km/h, up to Class 5',
      row5_3: 'up to 74 km/h, up to Class 5',
      colors: [
        {
          color: '010 (RAL 9003/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/010.jpg',
        },
        {
          color: '071 (VSR071/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/071.jpg',
        },
        {
          color: '110 (VSR110/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/110.jpg',
        },
        {
          color: '130 (RAL 7038/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/130.jpg',
        },
        {
          color: '140 (RAL 9006/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/140.jpg',
        },
        {
          color: '140H (RAL 9006/H)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/140H.jpg',
        },
        {
          color: '240 (VSR240/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/240.jpg',
        },
        {
          color: '266 (January2)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/266.jpg',
        },
        {
          color: '330 (RAL 3004/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/330.jpg',
        },
        {
          color: '716 (RAL 7016/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/716.jpg',
        },
        {
          color: '739 (RAL 7039)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/739.jpg',
        },
        {
          color: '780 (VSR780/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/780.jpg',
        },
        {
          color: '907 (RAL 9007/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/907.jpg',
        },
        {
          color: '910 (RAL 9010/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/910.jpg',
        },
        {
          color: 'DB703 (DB703/S)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/DB703.jpg',
        },
        {
          color: 'YW359F (YW359F)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/blinds-variants/C-65/YW359F.jpg',
        },
      ],
    },
  ],
  'Self-Bearing Systems': [
    {
      src: 'https://www.neva.eu/wp-content/cache/image/neva-samonosny-system-stf1-330x350-c-center.webp',
      src2: 'https://www.neva.eu/wp-content/cache/image/neva-samonosny-system-stf1-1-600x600-c-center.webp',
      type: 'Self-Bearing Systems',
      title: 'STF',
      description1: '+ Quick installation',
      description2: '+ Ideal for window manufacturers',
      description3: '+ Instect screens',
      link: '/product-details/Self-Bearing Systems/STF',
      detail1:
        'Thanks to the STF system, we can quickly and effectively install external blinds on a building. We shall prepare the system for you during production in such a manner that it suffices to unpack and install it.',
      detail2:
        'We make the STF self-bearing system in one of two versions. STF1 has visible guide profiles and you can use it mainly for retro-fitting into a building opening. You can use the STF2 system during plastering. Thanks to this, all the anchoring elements are hidden.',
      detail3:
        'The STF system allows window manufacturers to fit the blinds on the window directly during production. The window with blinds is then installed on the building in a single step.',
      row1: 'STF1 without additional anchorage',
      row1_2: 'Motor',
      row2: 'Blind width (mm)',
      row2_2: '600 - 2 300',
      row3: 'Blind height (mm)',
      row3_2: '500 - 3 500',
      row4: 'Maximum blind surface (m2)',
      row4_2: '8',
    },
    {
      src: 'https://www.neva.eu/wp-content/cache/image/neva-samonosny-system-stl-330x350-c-center.webp',
      src2: 'https://www.neva.eu/wp-content/cache/image/neva-samonosny-system-stl-2-600x600-c-center.webp',
      type: 'Self-Bearing Systems',
      title: 'STL',
      description1: '+ Quick installation',
      description2: '+ Variability',
      description3: '+ Reinforced STL system',
      link: '/product-details/Self-Bearing Systems/STL',
      detail1:
        'The STL self-supporting system is used for quick installation of external blinds on the prepared space in a building. The blinds form one unit with the bearing elements and guide profiles, which you can immediately fix in place upon unpacking.',
      detail2:
        'The STL system is mounted in the jamb or window frame. We can also make a reinforced STL system for you with a width of up to 4 metres. ',
      row1: 'STL standard version',
      row1_2: 'Crank',
      row1_3: 'Motor',
      row2: 'Blind width (mm)',
      row2_2: '600 - 2 300',
      row2_3: '600 - 2 300',
      row3: 'Blind height (mm)',
      row3_2: '500 - 3 500',
      row3_3: '500 - 3 500',
      row4: 'Maximum blind surface (m2)',
      row4_2: '8',
      row4_3: '8',
    },
  ],
  'Facade System': [
    {
      src: 'https://www.neva.eu/wp-content/cache/image/neva-fasadni-system-hranata-varianta-1-600x600-c-center.webp',
      src2: 'https://www.neva.eu/wp-content/cache/image/neva-fasadni-system-hranata-varianta-1-600x600-c-center.webp',
      type: 'Facade System',
      title: 'Facade System',
      description1:
        'If you want to install external blinds on a finished façade, façade blinds are an ideal technical solution.',
      description2:
        'We deliver them with a self-bearing case and massive guide profiles. Installers simply attach the blinds to the wall using special holders for the guide profile.',
      description3: '',
      link: '/product-details/Facade System/Facade System',
      detail1:
        'If you want to install external blinds on a finished façade, façade blinds are an ideal technical solution.',
      detail2:
        'We deliver them with a self-bearing case and massive guide profiles. Installers simply attach the blinds to the wall using special holders for the guide profile.',
      detail3:
        'We can make façade blinds for you in square design. This design has cover sheeting and angular guides. This option is a very interesting choice for architects who want to spice up the appearance of the facade and the complete look of the whole building.',
      row1: 'Façade system - square version',
      row1_2: 'Motor',
      row2: 'Blind width (mm)',
      row2_2: '600 - 3 950',
      row3: 'Blind height (mm)',
      row3_2: '500 - 4 000',
      row4: 'Maximum blind surface (m2)',
      row4_2: '11',
    },
  ],
  'Zip Screen': [
    {
      src: 'https://www.neva.eu/wp-content/cache/image/neva-latkove-rolety-zipscreen-zip100-dlazdice-1-2-330x350-c-center.webp',
      src2: 'https://www.neva.eu/wp-content/uploads/neva-latkove-rolety-zipscreen-zip100-hranata-vaianta-1.jpg',
      type: 'Zip Screen',
      title: 'ZIP100',
      description1: '+ modern, quiet and robust',
      description2: '+ subtle bottom profile',
      description3: '+ width of top box 100 mm',
      link: '/product-details/Zip Screen/ZIP100',
      detail1:
        'An elegant fabric roller screen which perfectly shades the home or pergola. We can make it for you from one of 21 fabrics, with a square or semi-rounded top box and with two types of bottom and guiding rails. One of them is tilting and screw-free, so that it looks better and substantially accelerates assembly. Operating the roller screens is also simplified by our unique shaft fixing system.',
      detail2:
        'We coat all the ZIP100 roller screen accessories in any RAL colour. We add another two years to the statutory two-year guarantee.',
      detail3:
        'We supply the ZIP100 roller screen with Somfy motors and shall gladly discuss the connection options for a smart home system with you.',
      row1: 'Zipscreen ZIP100',
      row1_2: 'Motor',
      row2: 'Roller screen width (mm)',
      row2_2: '700 — 4,000',
      row3: 'Roller screen height (mm)',
      row3_2: 'up to 3,500',
      row4: 'Maximum area of the roller screen (m2)',
      row4_2: '14 m2',
      row5: 'Wind resistance',
      row5_2: 'up to class 6',
      colors: [
        {
          color: '108101 A/B: Grey-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108101.png',
        },
        {
          color: '108108: Grey',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108108.png',
        },
        {
          color: '108112 A/B: Grey-sand',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108112.png',
        },
        {
          color: '108118 A/B: Grey-black',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108118.png',
        },
        {
          color: '112101 A/B: Sand-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/112101.png',
        },
        {
          color: '112113 A/B: Sand-bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/112113.png',
        },
        {
          color: '117101 A/B: Pearl-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/117101.png',
        },
        {
          color: '117108 A/B: Pearl-grey',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/117108.png',
        },
        {
          color: '117117: Pearl',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/117117.png',
        },
        {
          color: '118113 A/B: Black-bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118113.png',
        },
        {
          color: '118118: Black',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118118.png',
        },
        {
          color: '92-2043: Bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2043.png',
        },
        {
          color: '92-2044: White',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2044.png',
        },
        {
          color: '92-2047: Anthracite',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2047.png',
        },
        {
          color: '92-2048: Alu',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2048.png',
        },
        {
          color: '92-2171: Boulder',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2171.png',
        },
        {
          color: '108101 A/B: Grey-White (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108101.png',
        },
        {
          color: '108108 A/B: Grey (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108108.png',
        },
        {
          color: '108112 A/B: Grey-Sand (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108112.png',
        },
        {
          color: '108118 A/B: Grey-Black (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108118.png',
        },
        {
          color: '118118 A/B: Black (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118118.png',
        },
      ],
    },
    {
      src: 'https://www.neva.eu/wp-content/uploads/NEVA-latkove-rolety-zipscreen-ZIP110-detail-top.jpg',
      src2: 'https://www.neva.eu/wp-content/uploads/NEVA-latkove-rolety-zipscreen-ZIP110-full-front.jpg',
      type: 'Zip Screen',
      title: 'ZIP110',
      description1: '+ mounting under façade',
      description2: '+ ideal for pergolas',
      description3: '+ top box width of 110 mm',
      link: '/product-details/Zip Screen/ZIP110',
      detail1:
        'An external textile screen with which you will easily shade both your pergola and house. You will mount it elegantly under the façade and hide it by completely pulling it up fully. All the welds and screws are concealed, and you will appreciate the modern and clean appearance in its visible installation on a pergola or on large glazed areas. Thanks to its specially developed system, the screen is easy to maintain, you will replace the fabric or the motor without any screwing. ',
      detail2:
        'We coat all the ZIP110 roller screen accessories in any RAL colour. We add another two years to the statutory two-year guarantee.',
      detail3:
        'We supply the ZIP110 roller screen with Somfy motors and shall gladly discuss the connection options for a smart home system with you.',
      row1: 'Zipscreen ZIP110',
      row1_2: 'Motor',
      row2: 'Roller screen width (mm)',
      row2_2: 'up to 4 000',
      row3: 'Roller screen height (mm)',
      row3_2: 'up to 3,500',
      row4: 'Maximum area of the roller screen (m2)',
      row4_2: '14',
      row5: 'Wind resistance',
      row5_2: 'up to class 6',
      colors: [
        {
          color: '108101 A/B: Grey-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108101.png',
        },
        {
          color: '108108: Grey',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108108.png',
        },
        {
          color: '108112 A/B: Grey-sand',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108112.png',
        },
        {
          color: '108118 A/B: Grey-black',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108118.png',
        },
        {
          color: '112101 A/B: Sand-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/112101.png',
        },
        {
          color: '112113 A/B: Sand-bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/112113.png',
        },
        {
          color: '117101 A/B: Pearl-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full Butte/117101.png',
        },
        {
          color: '117108 A/B: Pearl-grey',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/117108.png',
        },
        {
          color: '117117: Pearl',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/117117.png',
        },
        {
          color: '118113 A/B: Black-bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118113.png',
        },
        {
          color: '118118: Black',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118118.png',
        },
        {
          color: '92-2043: Bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2043.png',
        },
        {
          color: '92-2044: White',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2044.png',
        },
        {
          color: '92-2047: Anthracite',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2047.png',
        },
        {
          color: '92-2048: Alu',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2048.png',
        },
        {
          color: '92-2171: Boulder',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2171.png',
        },
        {
          color: '108101 A/B: Grey-White (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108101.png',
        },
        {
          color: '108108 A/B: Grey (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108108.png',
        },
        {
          color: '108112 A/B: Grey-Sand (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108112.png',
        },
        {
          color: '108118 A/B: Grey-Black (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108118.png',
        },
        {
          color: '118118 A/B: Black (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118118.png',
        },
      ],
    },
    {
      src: 'https://www.neva.eu/wp-content/uploads/neva-latkove-rolety-zipscreen-zip135-dlazdice-2.jpg',
      src2: 'https://www.neva.eu/wp-content/uploads/neva-latkove-rolety-zipscreen-zip135-hranata-varianta.jpg',
      type: 'Zip Screen',
      title: 'ZIP135',
      description1: '+ modern, quiet and resistant',
      description2: '+ width up to 6 metres',
      description3: '+ top box width of 135 mm',
      link: '/product-details/Zip Screen/ZIP135',
      detail1:
        'It is an elegant fabric blind, which perfectly shades the house or pergola. We make them from one of 21 fabrics, with a square or semi-rounded top box and with a unique shaft fixture system, which substantially eases blind maintenance thanks to easy assembly and disassembly.',
      detail2:
        'We coat all the ZIP135 roller screen accessories in any RAL colour. We add another two years to the statutory two-year guarantee.',
      detail3:
        'We supply the ZIP135 blind with the Somfy motors and shall gladly discuss the connection options for a smart home system with you.',
      row1: 'Zipscreen ZIP135',
      row1_2: 'Motor',
      row2: 'Roller screen width (mm)',
      row2_2: 'up to 6 000',
      row3: 'Roller screen height (mm)',
      row3_2: 'up to 6,000',
      row4: 'Wind resistance',
      row4_2: 'up to class 6',
      colors: [
        {
          color: '108101 A/B: Grey-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108101.png',
        },
        {
          color: '108108: Grey',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108108.png',
        },
        {
          color: '108112 A/B: Grey-sand',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108112.png',
        },
        {
          color: '108118 A/B: Grey-black',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108118.png',
        },
        {
          color: '112101 A/B: Sand-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/112101.png',
        },
        {
          color: '112113 A/B: Sand-bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/112113.png',
        },
        {
          color: '117101 A/B: Pearl-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/117101.png',
        },
        {
          color: '117108 A/B: Pearl-grey',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/117108.png',
        },
        {
          color: '117117: Pearl',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/117117.png',
        },
        {
          color: '118113 A/B: Black-bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118113.png',
        },
        {
          color: '118118: Black',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118118.png',
        },
        {
          color: '92-2043: Bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2043.png',
        },
        {
          color: '92-2044: White',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2044.png',
        },
        {
          color: '92-2047: Anthracite',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2047.png',
        },
        {
          color: '92-2048: Alu',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2048.png',
        },
        {
          color: '92-2171: Boulder',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2171.png',
        },
        {
          color: '108101 A/B: Grey-White (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108101.png',
        },
        {
          color: '108108 A/B: Grey (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108108.png',
        },
        {
          color: '108112 A/B: Grey-Sand (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108112.png',
        },
        {
          color: '108118 A/B: Grey-Black (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108118.png',
        },
        {
          color: '118118 A/B: Black (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118118.png',
        },
      ],
    },
    {
      src: 'https://www.neva.eu/wp-content/uploads/NEVA-latkove-rolety-zipscreen-ZIP150-detail-top-0.jpg',
      src2: 'https://www.neva.eu/wp-content/uploads/NEVA-latkove-rolety-zipscreen-ZIP150-full-front.jpg',
      type: 'Zip Screen',
      title: 'ZIP150',
      description1: '+ mounting under façade',
      description2: '+ max. width of 6 metres',
      description3: '+ top box width of 150 mm',
      link: '/product-details/Zip Screen/ZIP150',
      detail1:
        'A modern external textile screen that will perfectly shade houses, administrative buildings and pergolas. Thanks to its fairly robust bottom rail, we can manufacture the screen up to 6 metres in width, that’s why it is suited for large glazed areas. You will mount it elegantly under the façade and hide it by completely pulling it up fully. Servicing will be made easier by a specially developed system, you can replace the fabric or motor without any screwing.',
      detail2:
        'We coat all the ZIP150 roller screen accessories in any RAL colour. We add another two years to the statutory two-year guarantee.',
      detail3:
        'We supply the ZIP150 blind with the Somfy motors and shall gladly discuss the connection options for a smart home system with you.',
      row1: 'Zipscreen ZIP150',
      row1_2: 'Motor',
      row2: 'Roller screen width (mm)',
      row2_2: 'up to 6 000',
      row3: 'Roller screen height (mm)',
      row3_2: 'up to 6,000',
      row4: 'Wind resistance',
      row4_2: 'up to class 6',
      colors: [
        {
          color: '108101 A/B: Grey-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108101.png',
        },
        {
          color: '108108: Grey',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108108.png',
        },
        {
          color: '108112 A/B: Grey-sand',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108112.png',
        },
        {
          color: '108118 A/B: Grey-black',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108118.png',
        },
        {
          color: '112101 A/B: Sand-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/112101.png',
        },
        {
          color: '112113 A/B: Sand-bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/112113.png',
        },
        {
          color: '117101 A/B: Pearl-white',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/117101.png',
        },
        {
          color: '117108 A/B: Pearl-grey',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/117108.png',
        },
        {
          color: '117117: Pearl',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/117117.png',
        },
        {
          color: '118113 A/B: Black-bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118113.png',
        },
        {
          color: '118118: Black',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118118.png',
        },
        {
          color: '92-2043: Bronze',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2043.png',
        },
        {
          color: '92-2044: White',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2044.png',
        },
        {
          color: '92-2047: Anthracite',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2047.png',
        },
        {
          color: '92-2048: Alu',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2048.png',
        },
        {
          color: '92-2171: Boulder',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/92-2171.png',
        },
        {
          color: '108101 A/B: Grey-White (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108101.png',
        },
        {
          color: '108108 A/B: Grey (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108108.png',
        },
        {
          color: '108112 A/B: Grey-Sand (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108112.png',
        },
        {
          color: '108118 A/B: Grey-Black (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/108118.png',
        },
        {
          color: '118118 A/B: Black (SERGÉ XINIX 0%)',
          imageLink:
            'https://www.neva.eu/wp-content/themes/neva/static/images/screens-variants/full/118118.png',
        },
      ],
    },
  ],
  'Insect screens': [
    {
      src: 'https://www.neva.eu/wp-content/cache/image/neva-sit-proti-hmyzu-samostatna-1-600x600-c-center.webp',
      src2: 'https://www.neva.eu/wp-content/uploads/neva-sit-proti-hmyzu-samostatna-1.jpg',
      type: 'Insect screens',
      title: 'Insect screens',
      description1: '+ easy and quick installation',
      description2: '+ suitable for any type of building',
      description3: '+ self-supporting system',
      link: '/product-details/Insect screens/Insect screens',
      detail1:
        'We can make custom rolling insect screens for you as integral parts of the STF self-supporting system.',
      detail2:
        'Screens are already adjusted during production and are ready for mounting. Screen profiles can be painted in any colour.',
      row1: 'Blueprint legend',
      row1_2: ' ',
      row2: '	Screen width (mm)',
      row2_2: '650 - 2 000',
      row3: 'Screen height (mm)',
      row3_2: '500 - 2 500',
    },
  ],
  'Shading Systems & Umbrellas': [
    {
      src: sh1,
      src2: sh1,
      type: 'Shading Systems & Umbrellas',
      title: 'Bioclimatic Pergola',
      description1: 'Adjustable aluminum louvers for precise light control',
      description2: 'Natural ventilation for year-round comfort',
      description3: 'Durable, modern all-season structure',
      link: '/product-details/Shading Systems & Umbrellas/Bioclimatic Pergola',
      row1: 'Max width',
      row1_2: '4m',
      row2: 'Length',
      row2_2: '6m',
    },
    {
      src: sh2,
      src2: sh2,
      type: 'Shading Systems & Umbrellas',
      title: 'Pergola',
      description1: 'Elegant outdoor shading solution',
      description2: 'Protects against sun and light rain',
      description3: 'Customizable size and design',
      link: '/product-details/Shading Systems & Umbrellas/Pergola',
      row1: 'Max width',
      row1_2: 'no limit',
      row2: 'Length',
      row2_2: '9m',
    },
    {
      src: sh3,
      src2: sh3,
      type: 'Shading Systems & Umbrellas',
      title: 'Glass Roof Cover',
      description1: 'Maximum natural daylight',
      description2: 'Weather-resistant safety glass',
      description3: 'Clean, modern architectural look',
      link: '/product-details/Shading Systems & Umbrellas/Glass Roof Cover',
      row1: 'Max width',
      row1_2: 'no limit',
      row2: 'Length',
      row2_2: '4m',
      row3: 'type',
      row3_2: 'transparent, blury',
    },
    {
      src: sh4,
      src2: sh4,
      type: 'Shading Systems & Umbrellas',
      title: 'Awning Over Glass',
      description1: 'Reduces heat and glare',
      description2: 'Protects glass surfaces',
      description3: 'Discreet and functional design',
      link: '/product-details/Shading Systems & Umbrellas/Awning Over Glass',
      detail1:
        'Effectively reduces heat gain and glare on glass roofs and façades.',
      detail2:
        'Protects glass surfaces from excessive sun exposure, extending their lifespan.',
      detail3:
        'Discreet design integrates seamlessly with existing glass structures.',
      row1: 'Max width',
      row1_2: '6m',
      row2: 'Length',
      row2_2: '5m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh5,
      src2: sh5,
      type: 'Shading Systems & Umbrellas',
      title: 'Polycarbonate Roof Cover',
      description1: 'Lightweight and impact-resistant',
      description2: 'UV and weather protection',
      description3: 'Cost-effective roofing solution',
      link: '/product-details/Shading Systems & Umbrellas/Polycarbonate Roof Cover',
      detail1:
        'Lightweight yet impact-resistant material ensures long-term reliability.',
      detail2:
        'Provides excellent UV protection while allowing diffused natural light.',
      detail3:
        'Cost-effective roofing solution suitable for residential and commercial use.',
      row1: 'Max width',
      row1_2: 'no limit',
      row2: 'Length',
      row2_2: '6m',
      row3: 'type',
      row3_2: 'transparent, blury',
    },
    {
      src: sh6,
      src2: sh6,
      type: 'Shading Systems & Umbrellas',
      title: 'Panel Roof Cover',
      description1: 'Strong and stable construction',
      description2: 'Full shade coverage',
      description3: 'Low maintenance system',
      link: '/product-details/Shading Systems & Umbrellas/Panel Roof Cover',
      detail1:
        'Solid panels deliver full shade and reliable weather protection.',
      detail2:
        'Strong and stable construction suitable for large outdoor areas.',
      detail3:
        'Low-maintenance system with long service life and clean appearance.',
      row1: 'Max-width',
      row1_2: 'no limit',
      row2: 'Length',
      row2_2: '6m',
    },
    {
      src: sh7,
      src2: sh7,
      type: 'Shading Systems & Umbrellas',
      title: 'Guillotine Glass (Vertical Sliding Glass)',
      description1: 'Motorized vertical sliding system',
      description2: 'Wind and noise protection',
      description3: 'Premium finish for outdoor spaces',
      link: '/product-details/Shading Systems & Umbrellas/Guillotine Glass (Vertical Sliding Glass)',
      detail1:
        'Motorized vertical sliding panels offer flexible opening and closing.',
      detail2:
        'Protects against wind, rain, and noise while maintaining visibility.',
      detail3:
        'Premium glass finish ideal for terraces, cafés, and luxury outdoor spaces.',
      row1: 'Max-width',
      row1_2: '3.40m',
      row2: 'Max-height',
      row2_2: '3.50m',
    },
    {
      src: sh8,
      src2: sh8,
      type: 'Shading Systems & Umbrellas',
      title: 'Sliding Glass Systems',
      description1: 'Smooth horizontal sliding panels',
      description2: 'Panoramic, unobstructed views',
      description3: 'Space-saving design',
      link: '/product-details/Shading Systems & Umbrellas/Sliding Glass Systems',
      detail1: 'Smooth horizontal sliding panels for effortless operation.',
      detail2: 'Panoramic, unobstructed views with maximum natural light.',
      detail3:
        'Space-saving design perfect for balconies, terraces, and winter gardens.',
      row1: 'Max width',
      row1_2: '5m',
      row2: 'Max height',
      row2_2: '3m',
    },
    {
      src: sh9,
      src2: sh9,
      type: 'Shading Systems & Umbrellas',
      title: 'Classic Awning',
      description1: 'Timeless and reliable design',
      description2: 'Effective sun protection',
      description3: 'Manual or motorized operation',
      link: '/product-details/Shading Systems & Umbrellas/Classic Awning',
      detail1: 'Proven, timeless design suitable for homes and businesses.',
      detail2:
        'Provides effective sun protection for windows and outdoor areas.',
      detail3:
        'Available with manual or motorized operation for added convenience.',
      row1: 'Max width',
      row1_2: '7m',
      row2: 'Length',
      row2_2: '3.50m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh10,
      src2: sh10,
      type: 'Shading Systems & Umbrellas',
      title: 'Cassette Awning',
      description1: 'Fully enclosed fabric protection',
      description2: 'Extended product lifespan',
      description3: 'Modern, clean appearance',
      link: '/product-details/Shading Systems & Umbrellas/Cassette Awning',
      detail1:
        'Fully enclosed cassette protects fabric and mechanism when retracted.',
      detail2:
        'Extends product lifespan by shielding it from weather and dirt.',
      detail3: 'Modern, streamlined appearance enhances building aesthetics.',
      row1: 'Max width',
      row1_2: '6m',
      row2: 'Length',
      row2_2: '3m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh11,
      src2: sh11,
      type: 'Shading Systems & Umbrellas',
      title: 'Wave Awning',
      description1: 'Decorative wave-style fabric',
      description2: 'Flexible shading solution',
      description3: 'Stylish visual effect',
      link: '/product-details/Shading Systems & Umbrellas/Wave Awning',
      detail1:
        'Distinctive wave-style fabric creates a decorative shading effect.',
      detail2: 'Flexible design adapts to various architectural requirements.',
      detail3:
        'Ideal for adding visual character to façades and outdoor spaces.',
      row1: 'Max width',
      row1_2: '4m',
      row2: 'Length',
      row2_2: '4m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh12,
      src2: sh12,
      type: 'Shading Systems & Umbrellas',
      title: 'ZIP Screen Awning',
      description1: 'Wind-resistant ZIP guide system',
      description2: 'Sun and insect protection',
      description3: 'Modern vertical shading',
      link: '/product-details/Shading Systems & Umbrellas/ZIP Screen Awning',
      detail1: 'ZIP guide system ensures high wind resistance and stability.',
      detail2:
        'Effectively blocks sun, heat, and insects while maintaining visibility.',
      detail3:
        'Contemporary vertical shading solution for windows, pergolas, and façades.',
      row1: 'Max width',
      row1_2: '4.50m',
      row2: 'height',
      row2_2: '3.50m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh13,
      src2: sh13,
      type: 'Shading Systems & Umbrellas',
      title: 'Cassette Curtain Awning',
      description1: 'Fabric protected inside cassette',
      description2: 'Elegant curtain-style shading',
      description3: 'Enhanced outdoor privacy',
      link: '/product-details/Shading Systems & Umbrellas/Cassette Curtain Awning',
      detail1: 'Curtain fabric is fully protected inside an aluminum cassette.',
      detail2:
        'Provides elegant vertical shading and enhanced outdoor privacy.',
      detail3: 'Ideal for terraces, balconies, and pergola side closures.',
      row1: 'Max width',
      row1_2: '4.50m',
      row2: 'height',
      row2_2: '3.50m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh14,
      src2: sh14,
      type: 'Shading Systems & Umbrellas',
      title: 'Curtain Awning',
      description1: 'Soft light filtering',
      description2: 'Privacy and sun protection',
      description3: 'Versatile installation options',
      link: '/product-details/Shading Systems & Umbrellas/Curtain Awning',
      detail1: 'Softly filters sunlight to create a comfortable atmosphere.',
      detail2: 'Offers reliable privacy and sun protection for outdoor spaces.',
      detail3:
        'Versatile installation options for residential and commercial use.',
      row1: 'Max width',
      row1_2: '6m',
      row2: 'height',
      row2_2: '4m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh15,
      src2: sh15,
      type: 'Shading Systems & Umbrellas',
      title: 'Window Cassette Awning',
      description1: 'Compact cassette system',
      description2: 'Reduces indoor heat',
      description3: 'Discreet window protection',
      link: '/product-details/Shading Systems & Umbrellas/Window Cassette Awning',
      detail1:
        'Compact cassette design protects the awning fabric when not in use.',
      detail2: 'Reduces indoor heat buildup and glare from direct sunlight.',
      detail3: 'Discreet solution that blends seamlessly with window façades.',
      row1: 'Max width',
      row1_2: '5m',
      row2: 'height',
      row2_2: '3.20m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh16,
      src2: sh16,
      type: 'Shading Systems & Umbrellas',
      title: 'Window Awning',
      description1: 'Direct sunlight control',
      description2: 'Improves energy efficiency',
      description3: 'Simple and effective design',
      link: '/product-details/Shading Systems & Umbrellas/Window Awning',
      detail1: 'Directly blocks sunlight before it reaches the glass surface.',
      detail2: 'Improves indoor comfort and energy efficiency.',
      detail3: 'Simple, functional design suitable for various window types.',
      row1: 'Max width',
      row1_2: '5m',
      row2: 'height',
      row2_2: '3.20m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh17,
      src2: sh17,
      type: 'Shading Systems & Umbrellas',
      title: 'Balcony Awning',
      description1: 'Ideal for balconies and apartments',
      description2: 'Increased privacy and shade',
      description3: 'Space-efficient solution',
      link: '/product-details/Shading Systems & Umbrellas/Balcony Awning',
      detail1: 'Designed specifically for balconies and apartment buildings.',
      detail2: 'Enhances privacy while providing effective sun protection.',
      detail3: 'Space-efficient solution without compromising outdoor comfort.',
      row1: 'Max width',
      row1_2: '6m',
      row2: 'height',
      row2_2: '3m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh18,
      src2: sh18,
      type: 'Shading Systems & Umbrellas',
      title: 'Commercial / Shop Awning',
      description1: 'Enhances brand visibility',
      description2: 'Improves customer comfort',
      description3: 'Weather protection for storefronts',
      link: '/product-details/Shading Systems & Umbrellas/Commercial / Shop Awning',
      detail1: 'Increases brand visibility and storefront appeal.',
      detail2:
        'Improves customer comfort by providing shade and weather protection.',
      detail3: 'Customizable with logos, colors, and branding elements.',
      row1: 'Max width',
      row1_2: '7m',
      row2: 'height',
      row2_2: '7m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh19,
      src2: sh19,
      type: 'Shading Systems & Umbrellas',
      title: 'Arched Awning',
      description1: 'Elegant curved design',
      description2: 'Decorative architectural accent',
      description3: 'Custom-fit solution',
      link: '/product-details/Shading Systems & Umbrellas/Arched Awning',
      detail1: 'Elegant curved shape adds a decorative architectural accent.',
      detail2: 'Provides reliable protection from sun and light rain.',
      detail3:
        'Custom-fit solution suitable for windows, doors, and entrances.',
      row1: 'Max width',
      row1_2: '5.50m',
      row2: 'height',
      row2_2: '1.50m',
      row3: 'colors',
      row3_2: '10+ colors available',
    },
    {
      src: sh20,
      src2: sh20,
      type: 'Shading Systems & Umbrellas',
      title: 'Glass Entrance Canopy',
      description1: 'Protects entrances from weather',
      description2: 'Modern architectural appearance',
      description3: 'Durable safety glass construction',
      link: '/product-details/Shading Systems & Umbrellas/Glass Entrance Canopy',
      detail1:
        'Protects building entrances from rain, snow, and direct sunlight.',
      detail2: 'Made from durable safety glass with strong support structures.',
      detail3: 'Modern, refined appearance that enhances the building façade.',
      row1: 'Max width',
      row1_2: '2m',
      row2: 'height',
      row2_2: '1.20m',
      row3: 'colors',
      row3_2: 'elox, antracit',
      row4: 'construction',
      row4_2: 'Alumin',
    },
  ],
};

/* eslint-disable */
export const colorMap: { [key: string]: string } = {
  // External Blinds - Z-90
  'RAL 9003': '#FFFCF7',
  'VSR071': '#301E0E',
  'VSR110': '#786238',
  'RAL 7038': '#7C8676',
  'RAL 9006': '#989DA1',
  'RAL 9006/H': '#989DA1',
  'VSR240': '#AA9053',
  'January2': '#393937',
  'RAL 3004': '#481210',
  'RAL 7016': '#1C2720',
  'RAL 7021': '#000E0F',
  'RAL 7022': '#282B16',
  'RAL 7035': '#D0D0C8',
  'RAL 7037': '#3F4536',
  'RAL 7039': '#76776B',
  'VSR780': '#4D4B29',
  'RAL 9005': '#000000',
  'RAL 9007': '#555545',
  'SW203G': '#383A2C',
  'RAL 9010': '#FFFDE3',
  'DB703': '#313126',
  'YW359F': '#30302D',

  // External Blinds - F-80
  'RAL 9003/H': '#FFFCF7', // 010H (RAL 9003/H)
  'RAL 7016/H': '#1C2720', // 716H (RAL 7016/H)
  'RAL 9007/H': '#555545', // 907H (RAL 9007/H)
  'SW203G/H': '#383A2C', // 908H (SW203G/H)

  // Zip Screen - ZIP100
  '108101': '#565662', // 108101 A/B: Grey-white
  '108108': '#48494F', // 108108: Grey
  '108112': '#6A564D', // 108112 A/B: Grey-sand
  '108118': '#4A4A4A', // 108118 A/B: Grey-black
  '112101': '#9A7155', // 112101 A/B: Sand-white
  '112113': '#7E6753', // 112113 A/B: Sand-bronze
  '117101': '#9A9A99', // 117101 A/B: Pearl-white
  '117108': '#837F7C', // 117108 A/B: Pearl-grey
  '117117': '#A2A2A0', // 117117: Pearl
  '118113': '#352B28', // 118113 A/B: Black-bronze
  '118118': '#121212', // 118118: Black
  '92-2043': '#564941', // 92-2043: Bronze
  '92-2044': '#EBEBE6', // 92-2044: White
  '92-2047': '#37383C', // 92-2047: Anthracite
  '92-2048': '#B2B2B2', // 92-2048: Alu
  '92-2171': '#D2D3CB', // 92-2171: Boulder
};
